import { Box, Button, CircularProgress, TextField, Typography, useTheme } from '@mui/material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { useWaits } from '../hooks/UseWait';
import { useConstants } from '../hooks/UseConstants';
import Fetch from '../services/Fetch';
import { useUpdatePassword } from '../hooks/UseUpdatePassword';
import { buildUpdatePasswordFormData } from '../helper/UpdatePasswordFormData';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';

function UpdatePassword({ onClickCancel, setSnackBar }) {
    const { host } = useConstants();
    const { sendWait, setSendWait } = useWaits();
    const { password, setPassword, newPassword, setNewPassword, confirmNewPassword, setConfirmNewPassword } = useUpdatePassword();
    const theme = useTheme();

    const resetInputs = () => {
        setPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
    };

    const updatePassword = async () => {
        setSendWait(true);
        const formData = buildUpdatePasswordFormData({
            oldPassword: password,
            newPassword,
            confirmPassword: confirmNewPassword,
        });

        const result = await Fetch(host + '/account/update-password', 'POST', formData);

        if (result.status === 200) {
            resetInputs();
            setSnackBar('success', 'تم تحديث كلمة المرور');
            onClickCancel();
        } else if (result.status === 422 || result.status === 400) {
            setSnackBar('error', result.data?.errors?.[0] || 'تعذر التحديث');
        }

        setSendWait(false);
    };

    return (
        <Box sx={{ background: theme.palette.background.paper }} className="w-1/2 rounded-xl py-3 px-5 max-sm:w-5/6">
            <Box className="w-20 h-20 rounded-full mx-auto my-5 flex justify-center items-center" sx={{ background: '#E8EEFD' }}>
                <LockResetOutlinedIcon className="text-blue-500 !text-5xl" />
            </Box>
            <Typography variant="h5" fontWeight={800} className="text-center">إعادة تعيين كلمة المرور</Typography>
            <TextField className="w-full !mt-5" type="password" label="كلمة المرور الحالية" value={password} onChange={(e) => setPassword(e.target.value)} />
            <TextField className="w-full !mt-5" type="password" label="كلمة المرور الجديدة" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
            <TextField className="w-full !mt-5" type="password" label="تأكيد كلمة المرور" value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} />
            <Box className="py-3 flex justify-between gap-2 max-sm:flex-col">
                <Button onClick={updatePassword} variant="contained" className="flex-1 !py-3" disabled={sendWait}>
                    {sendWait ? <CircularProgress size={20} color="inherit" /> : <>حفظ<SaveOutlinedIcon className="mr-1" /></>}
                </Button>
                <Button onClick={() => { resetInputs(); onClickCancel(); }} variant="contained" color="inherit" className="flex-1 !py-3">
                    إلغاء
                </Button>
            </Box>
        </Box>
    );
}

export default UpdatePassword;
